// DOM ids of the remote islands. Shared by resolveFragments and App so the literal never drifts
// between fetch and render.
export const SITE_HEADER_ISLAND_ID = 'oseo-header';
export const SITE_FOOTER_ISLAND_ID = 'oseo-footer';
